import React from 'react';
import style from './Loading.scss';

export default function Loading() {
  return <span className={style.spinner}></span>;
}
